var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"title":_vm.$t('navbar.menu'),"closable":true,"visible":_vm.visible,"maskClosable":false,"bodyStyle":{padding: 0},"width":"300"},on:{"close":_vm.onClose}},[_c('menu-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }